<template>
	<!-- 首页二级导航 --- 话题 -->
	<div class="huatiBox">
		<div class="biaoqianTitle">
			<h4>热门话题</h4>
			<!-- <img src="../../assets/img/arr.png" alt=""> -->
		</div>
		<div class="shouyeQt">
			<div class="qt_list">
				<p v-for="(item,idx) in hotTalk" :key="idx">{{item.content}}</p>
			</div>
			<div class="thicon" @click="hypFn">
				<span>换一批</span>
				<img src="../../assets/img/hyp.png" alt="">
			</div>
		</div>
		<div class="biaoqianTitle bgcF0">
			<h4>实时讨论</h4>
			<!-- <img src="../../assets/img/arr.png" alt=""> -->
		</div>
		<!-- 实时讨论列表 -->
		<div class="forumListBox">
			<div class="forumListItem" v-for="(item,index) in newestComments" @click="jumpUrlPlFn(item.c_type,item.c_id)">
				<!-- 头像栏 -->
				<div class="forum_top">
					<div class="forum_top_left">
						<div class="userImg">
							<img :src="$api.$BASE_URL_img + item.avatar" alt=""/>
							<div class="timeInfo">
								<span class="wname" v-if="item.anonymous == 1">匿名</span>
								<span class="wname" v-else>{{item.nickname}}</span>
								<p><span>{{formatDateTime(item.createtime)}}</span></p>
							</div>
						</div>
						<p class="bookName">《{{item.c_name}}》</p>
					</div>
					<!-- <div class="forum_top_right"><span>第<i>2</i>章</span><span><i>{{item.c_score}}</i>分</span></div> -->
					<div class="forum_top_right"><span><i>{{item.c_score}}</i>分</span></div>
				</div>

				<div class="forum_middle">
					<p v-html="item.c_content"></p>
					<!-- <div class="btnHf"><button>回复</button></div> -->
					<div class="btnHf" @click="go_reply(item.id)">
						<img src="../../assets/img/xiaoxi.png" alt="">
						<span>{{item.reply.length}}</span>
					</div>
				</div>
				<div class="er_reply" v-if="item.reply.length">
					<div :class="!item.show_comment ? 'list_item threelist' : 'list_item'" 
						 v-for='(it,index1) in item.reply' 
						 :key='it.id' 
					>
						<p class="top_text">
							<!-- <span class="name">{{it.nickname}}</span> -->
							<span class="name" v-if="it.anonymous == 1">匿名</span>
							<span class="name" v-else>{{it.nickname}}</span>
							<span class="floor">{{index1+1}}楼</span>
						</p>
						<p class="time"><span class="er_reply_time">{{formatDateTime(it.createtime)}}</span></p>
						<p class="content" v-html="it.c_content"></p>
						
					</div>
				</div>
				<div v-if="item.reply.length > 3"  @click="showComment(index)" class="more_comment" >
					<span>
						 {{!item.show_comment ? '更多评论' : '收起评论'}}
					</span>
					<img src="../../assets/img/rightArrs.png" alt="">
				</div>
			</div>
			<!-- 回复 -->
			<!-- <div class="mask_view" v-show="reply_show" @touchmove.prevent @click="hide_reply()">
				<div class="comment_input" @click.stop>
					<div class="input_hf">
						<input type="text" v-model="comment_text" placeholder="回复TA..." />
						<img src="../../assets/img/sdadd.png" alt="">
					</div>
					<span @click="goReply">发送</span>
				</div>
			</div> -->
		</div>
		
	</div>
</template>

<script>
	import qs from 'qs';
	export default {
		data() {
			return {
				hotTalk:[],
				newestComments:[],
				comment_text: '',
				reply_show: false,
				pid: '',
			}
		},
		created() {
			this.hot_talk();
			this.newest_comments();
		},
		methods:{
			hypFn(){
				this.hot_talk();
			},
			jumpUrlPlFn(type,huatiTlId){
				if(type == 1){
					this.$router.push({path:'/comment',query:{book_id:huatiTlId}})
				}else if(type == 2){
					this.$router.push({path:'/bookPinglun',query:{list_id:huatiTlId}})
				}else if(type == 3){
					this.$router.push({path:'/tieziInfo',query:{tzxqInfoId:huatiTlId}})
				}
			},
			hot_talk(){
				this.$axios.post(this.$api.hot_talk).then(res =>{
					this.hotTalk = res.data.data;
				})
			},
			newest_comments(){
				this.$axios.post(this.$api.newest_comments).then(res =>{
					this.newestComments = res.data.data
				})
			},
			formatDateTime(dateNum) {
				var date = new Date(dateNum * 1000);
				return date.getFullYear() + "-" + fixZero(date.getMonth() + 1, 2) + "-" + fixZero(date.getDate(), 2) + " " +
					fixZero(date.getHours(), 2) + ":" + fixZero(date.getMinutes(), 2) + ":" + fixZero(date.getSeconds(), 2);
			
				function fixZero(num, length) {
					var str = "" + num;
					var len = str.length;
					var s = "";
					for (var i = length; i-- > len;) {
						s += "0";
					}
					return s + str;
				}
			},
			go_reply(id) {
				console.log(id)
				var _t = this;
				_t.reply_show = true;
				_t.pid = id;
			},
			goReply() { //回复
				var _t = this;
				let comment = {
					pid: _t.pid,
					content: _t.comment_text,
				}
				_t.$axios.post(_t.$api.book_comment + '?' + qs.stringify(comment)).then(res => {
					if (res.data.code == 1) {
						_t.$toast(res.data.msg);
						_t.newest_comments();
						_t.comment_text = '';
						_t.reply_show = false;
						_t.pid = '';
					} else {
						_t.$toast(res.data.msg);
					}
				})
			},
			hide_reply() {
				this.reply_show = false;
			},
			//展示更多评论
			showComment(index) {
				// 因为vue的机制，在渲染玩完成后新添加的数据要用$set
				if (!this.newestComments[index].show_comment) {
					this.$set(this.newestComments[index], 'show_comment', true);
				} else {
					// 当有了数据就用正常的取反就行了
					this.newestComments[index].show_comment = !this.newestComments[index].show_comment;
				}
			},
		}
	}
</script>

<style lang="less" scoped>
	.huatiBox {
		background-color: #fff;
		padding-top: 60px;
		overflow-y: scroll;
		height: calc(100vh - 220px);
	}

	// 标题
	.biaoqianTitle {
		position: relative;
		background-color: #fff;
		padding: 0 16px;

		h4 {
			color: #ff4081;
			padding: 20px 0;
			line-height: 40px;
			font-size: 30px;
			/*px*/
			font-weight: 700;
		}

		img {
			position: absolute;
			top: 50%;
			right: 10px;
			transform: translateY(-50%) rotate(270deg);
			width: 35px;
		}
	}

	//首页强推
	.shouyeQt {
		background-color: #fff;
		padding: 0 16px;

		.qt_list {
			overflow: hidden;

			p {
				// width: calc(50% - 20px);
				padding: 0px 20px;
				margin-right: 10px;
				margin-bottom: 10px;
				float: left;
				line-height: 60px;
				font-size: 26px;
				/*px*/
				color: #585455;
				background-color: #fff4f8;
				border-radius: 80px;
			}
		}

		.thicon {
			margin: 0 auto;
			padding-top: 20px;
			text-align: center;

			span {
				color: #999;
				padding-right: 10px;
			}

			img {
				vertical-align: middle;
				width: 30px;
			}
		}

	}

	//实时讨论
	.forumListBox {
		padding: 0 16px;
		height: 63vh;
		overflow: scroll;
		.forumListItem:last-child {
			border-bottom: 0px;
		}

		.forumListItem {
			padding-bottom: 24px;
			border-bottom: 1px solid #f0f0f0;
			/*no*/
			background-color: #fff;
			
			.forum_top {
				display: flex;
				padding: 24px 0;
				justify-content: space-between;
				padding-bottom: 14px;

				.forum_top_left {
					flex: 1;
					display: flex;
					justify-content: space-between;

					.userImg {
						overflow: hidden;
						display: flex;

						img {
							width: 80px;
							height: 80px;
							float: left;
							border-radius: 50%;
							box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.4);
						}

						.timeInfo {
							color: #a3a3a3;
							flex: 1;

							.wname {
								display: inline-block;
								// line-height: 80px;
								padding-left: 24px;
								// float: right;
								color: #3d3d3d;
								font-size: 28px;
								/*px*/
							}

							p {
								padding-top: 10px;
								padding-left: 20px;

								.time {
									padding-left: 10px;
								}
							}
						}
					}

					.bookName {
						flex: 1;
						text-align: left;
						padding-left: 50px;
						// line-height: 80px;
						color: #4f4f4f;
						font-size: 26px;
						/*px*/
					}
				}

				.forum_top_right {
					width: 80px;
					text-align: right;
					// line-height: 80px;
					// color: #b8b8b8;
					color: #737373;
					font-size: 28px;

					/*px*/
					span {
						padding-right: 10px;

						i {
							font-style: normal;
							color: #81c5f7;
						}
					}

					span:last-child {
						padding: 0;
					}
				}
			}

			.forum_middle {
				position: relative;
				font-size: 26px;/*px*/
				p {
					color: #3d3d3d;
					line-height: 50px;
					width: 90vw;
				}

				.btnHf {
					width: 100px;
					button {
						position: absolute;
						bottom: 0;
						right: 0;
						background-color: #fff;
						border: 1px solid #ff748c;
						/*px*/
						color: #ff748c;
						line-height: 40px;
						padding: 0 20px;
						border-radius: 6px;
						display: inline-block;
					}

					img {
						position: absolute;
						bottom: 0;
						right: 20px;
						width: 50px;
					}
					span{
						position: absolute;
						bottom: 0;
						right: 0px;
						line-height: 50px;
						display: inline-block;
					}
				}
			}

			.forum_bottom {
				padding-top: 10px;

				span {
					color: #a3a3a3;
					padding-right: 10px;
				}
			}
			
			.er_reply {
				color: #767676;
				padding: 10px 30px;
				border-radius: 4px;
				.list_item {
					line-height: 50px;
					padding:0 30px;
					box-sizing: border-box;
					border-bottom: 1px solid #fff;
					background-color: #f0f0f0;
					
					.top_text{
						width:100%;
						display: flex;
						flex-direction: row;
						justify-content: space-between;
						
						.name{
							color: #3d3d3d;
						}
						
						.floor{
							color: #ff4081;
						}
					}
					
					.content{
						overflow: hidden;
						width:100%;
						max-height:95px;
					}
					
					.time{
						width:100%;
						display: flex;
						// justify-content: flex-end;
						
						
						.er_reply_time {
							font-size: 24px;
							/*px*/
							color: #848484;
							// margin-left: 20px;
						}
					}
				}
				
				.list_item:last-child{
					border-bottom: 0;
				}
				
				.threelist{
					display: none;
				}
				.threelist:nth-child(1){
					display: block;
				}
				.threelist:nth-child(2){
					display: block;
				}
				.threelist:nth-child(3){
					display: block;
				}
			}
			
			.more_comment{
				padding: 14px 10px;
				color:#666666;
				text-align: center;
				display: flex;
				flex-direction: row;
				justify-content: center;
				align-items: center;
				color: #ff4081;
				
				img{
					width:25px;
					margin-left:10px;
				}
			}
		}
		// 回复
		.mask_view{
			position: absolute;
			// background: #000;
			bottom: -50px;
			left: 0;
			z-index: 999;
			.comment_input {
				position: absolute;
				z-index: 998;
				bottom: 160px;
				left: 0;
				width: 100vw;
				height: 80px;
				padding: 20px 0;
				background-color: #fff;
				border-top: 1px solid #f0f0f0;
			
				/*no*/
				.input_hf {
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					width: 80%;
					margin-left: 16px;
					height: 80px;
					line-height: 80px;
					border-radius: 80px;
					position: relative;
					border: 1px solid #fa7298;
			
					/*no*/
					input {
						width: 82%;
						background-color: transparent;
						padding-left: 20px;
						border-radius: 80px;
					}
			
					img {
						position: absolute;
						top: 50%;
						right: 20px;
						transform: translateY(-50%);
						width: 50px;
					}
				}
			
				span {
					text-align: center;
					position: absolute;
					top: 50%;
					right: 10px;
					transform: translateY(-50%);
					background-color: #fa7298;
					color: #fff;
					padding: 15px 30px;
					border-radius: 20px;
				}
			}
			
		}
	}
	
	
</style>
